import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import Confirm from "./components/pages/Confirm";
import Auth from "./components/pages/Auth";
import AdminDashboard from "./components/pages/AdminDashboard";

export default {
  getRoutes() {
    return <Routes>
      <Route path="/" element={<Auth />} />
      <Route path="/confirm" element={<Confirm />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path='/*' element={<Navigate to={'/'} replace={true}/>} />
    </Routes>
  }
}
